import { render, staticRenderFns } from "./EditTabInfo.vue?vue&type=template&id=6d4fcf84"
import script from "./EditTabInfo.vue?vue&type=script&lang=js"
export * from "./EditTabInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports